import React, { useState } from 'react';
import SearchInput from './SearchInput';
import FilterSectionHeader from './FilterSectionHeader';
import { US_STATES } from '../../../config/configExtras';
import css from './FilterSidebar.module.css';

const StateFilterSection = ({
  handleClearFilter,
  handleCheckboxChange,
  selectedValues,
  paramKey,
  labelId,
}) => {
  // Local search state
  const [searchTerm, setSearchTerm] = useState('');

  // Filter states based on search term and limit to 10
  const displayedStates = searchTerm.trim()
    ? US_STATES.filter(state =>
        state.label.toLowerCase().includes(searchTerm.trim().toLowerCase())
      ).slice(0, 10)
    : [];

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  return (
    <div className={css.filterSection}>
      <FilterSectionHeader
        titleId={labelId ? labelId : 'FilterCategories.location'}
        handleClear={handleClear}
      />

      {/* Search Input */}
      <SearchInput
        placeholder="Search States..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />

      {/* Show states only if there’s a search term with matches */}
      {searchTerm.trim() && displayedStates.length > 0 && (
        <div className={css.scrollable}>
          {displayedStates.map((s, index) => {
            const optionKey = s.value;
            const isChecked = selectedValues.includes(optionKey);
            return (
              <label
                key={`${s.value}-${index}`} // Random key per request (consider a stable key if possible)
                className={css.checkboxLabel}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  value={optionKey}
                  onChange={e => handleCheckboxChange(e, paramKey)}
                  name="state"
                />
                <span>{s.label}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StateFilterSection;
